// --------------------------------------------------------------------------
// Appeal listing
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {

    var context = options.context;

    function init() {

        context.on('click', '[data-behavior="appeals-load-more"]', function (e) {
            e.preventDefault();
            context.find('[data-binding="appeals-more-list"]').show();
            $(this).parent().hide();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/appeals-list.js
// module id = 490
// module chunks = 0